import { render } from "./TelaAdm.vue?vue&type=template&id=63b1a927&scoped=true"
import script from "./TelaAdm.vue?vue&type=script&lang=js"
export * from "./TelaAdm.vue?vue&type=script&lang=js"

import "./TelaAdm.vue?vue&type=style&index=0&id=63b1a927&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3986129723/src/app-csd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63b1a927"]])

export default __exports__